// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./abhaConfirmationDetails.scss";
import moment from "moment";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaConfirmationDetails = (props) => {
  // const declarations ⇒
  const { appointmentDetails, abhPatientDetails } = props;

  // let or var declarations ⇒
  let dateFormats = [
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "MM/DD/YYYY",
    "MM-DD-YYYY",
  ];

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  // create UI ⇒

  const getLabelAndData = (label, data) => {
    return (
      <div className="acd-content-wrapper">
        <div className="acd-label">{label}</div>
        <div className="acd-data">{data ?? "-"}</div>
      </div>
    );
  };

  const renderAbhaPatientDetails = () => {
    return (
      <div className="acd-wrapper">
        <div className="acd-left-content">
          <div className="acd-heading">Existing Patient Details</div>
          <div>
            {getLabelAndData("Patient Name", appointmentDetails?.patient_name)}
          </div>
          <div>
            {getLabelAndData(
              "Date of Birth",
              appointmentDetails?.patient_dob &&
                moment(appointmentDetails?.patient_dob).format("DD/MM/YYYY")
            )}
          </div>
          <div className="acd-last-data">
            {getLabelAndData("Gender", appointmentDetails?.patient_gender)}
          </div>
          <div className="acd-last-data">
            {getLabelAndData("Address", appointmentDetails?.patient_address)}
          </div>
          <div className="acd-last-data">
            {getLabelAndData("State", appointmentDetails?.patient_state)}
          </div>
        </div>
        <div className="acd-right-content">
          <div className="acd-heading">ABHA Patient Details</div>
          <div>{getLabelAndData("Patient Name", abhPatientDetails?.name)}</div>
          <div>
            {getLabelAndData(
              "Date of Birth",
              abhPatientDetails?.dob &&
                moment(abhPatientDetails?.dob, dateFormats).format("DD/MM/YYYY")
            )}
          </div>
          <div className="acd-last-data">
            {getLabelAndData("Gender", abhPatientDetails?.gender)}
          </div>
          <div className="acd-last-data">
            {getLabelAndData("Address", abhPatientDetails?.address)}
          </div>
          <div className="acd-last-data">
            {getLabelAndData("State", abhPatientDetails?.state)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="abha-confirmation-details">
      {renderAbhaPatientDetails()}
    </div>
  );
};

// export ⇒

export default AbhaConfirmationDetails;
